'use client';

import { c as _c } from "react/compiler-runtime";
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import arrow from '@images/renders/location_images/mapIcon/arrow.svg';
import logo from '@images/renders/location_images/mapIcon/logoMap.svg';
import minusIcon from '@images/renders/location_images/mapIcon/minus.svg';
import plusIcon from '@images/renders/location_images/mapIcon/plus.svg';
import { mapFilters, mapPins } from '@lib/tools/helpers/constants';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { Clusterer, Placemark, Map as YMap, YMaps } from '@pbe/react-yandex-maps';
import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';
import Svg from 'react-inlinesvg';
import { LocationPlacemark } from '../location-placemark/LocationPlacemark';
import style from './LocationMap.module.scss';
const mapOptions = {
  yandexMapDisablePoiInteractivity: true,
  minZoom: 7,
  copyrightLogoVisible: false,
  copyrightProvidersVisible: false,
  copyrightUaVisible: false,
  suppressMapOpenBlock: true
};
const LocationMap = t0 => {
  const $ = _c(96);
  const {
    breadCrumbsApi
  } = t0;
  const {
    isDesktop,
    isMobile
  } = useViewport();
  const [ymaps, setYmaps] = useState(null);
  const [myMap, setMyMap] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [55.812803, 37.482053];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [currentCoords] = useState(t1);
  const [zoom, setZoom] = useState(14);
  const [warningShow, setWarningShow] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [placemarksArr, setPlacemarksArr] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [filteredPlacemarks, setFilteredPlacemarks] = useState(t3);
  const [activeFilter, setActiveFilter] = useState("all");
  const [filtersOpen, setFiltersOpen] = useState(!isMobile);
  const activePlacemarkRef = useRef(null);
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (mapPins) {
        const arr = [];
        mapPins.forEach(item => {
          item.values.forEach(el => {
            el.id = crypto.randomUUID();
            arr.push(el);
            return true;
          });
          return true;
        });
        setPlacemarksArr(arr);
        setFilteredPlacemarks(arr);
      }
    };
    t5 = [];
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => {
      if (e.touches.length === 1) {
        setWarningShow(true);
      }
      if (e.touches.length === 2) {
        setWarningShow(false);
      }
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleMapMove = t6;
  let t7;
  if ($[6] !== placemarksArr) {
    t7 = category => {
      const filteredPins = placemarksArr.filter(place => place.category === category);
      setFilteredPlacemarks(filteredPins.length > 0 ? filteredPins : placemarksArr);
    };
    $[6] = placemarksArr;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const filterPins = t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      if (activePlacemarkRef.current) {
        activePlacemarkRef.current.balloon.close();
      }
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const onMapClick = t8;
  let t9;
  if ($[9] !== myMap) {
    t9 = e_0 => {
      const cluster = e_0.get("target");
      const objects = cluster.getGeoObjects();
      const bounds = objects.bounds.getBounds();
      myMap.setBounds(bounds, {
        checkZoomRange: true
      });
      setZoom(myMap.getZoom());
    };
    $[9] = myMap;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const onClusterClick = t9;
  let t10;
  if ($[11] !== myMap || $[12] !== zoom) {
    t10 = e_1 => {
      const newZoom = e_1.get("newZoom");
      if (newZoom < zoom) {
        myMap.setZoom(zoom);
      }
    };
    $[11] = myMap;
    $[12] = zoom;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const onZoomChange = t10;
  let t11;
  let t12;
  if ($[14] !== isDesktop || $[15] !== myMap || $[16] !== ymaps) {
    t11 = () => {
      if (myMap && ymaps) {
        if (myMap.behaviors.isEnabled("scrollZoom")) {
          myMap.behaviors.disable("scrollZoom");
        }
        if (!isDesktop) {
          if (!myMap.behaviors.isEnabled("multiTouch")) {
            myMap.behaviors.enable("multiTouch");
          }
          if (myMap.behaviors.isEnabled("drag")) {
            myMap.behaviors.disable("drag");
          }
        } else {
          if (!myMap.behaviors.isEnabled("drag")) {
            myMap.behaviors.enable("drag");
          }
          if (myMap.behaviors.isEnabled("multiTouch")) {
            myMap.behaviors.disable("multiTouch");
          }
        }
      }
    };
    t12 = [myMap, ymaps, isDesktop];
    $[14] = isDesktop;
    $[15] = myMap;
    $[16] = ymaps;
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  useEffect(t11, t12);
  let t13;
  if ($[19] !== breadCrumbsApi) {
    t13 = <div className={style.breadCrumbs}><BreadCrumbs item={breadCrumbsApi} /></div>;
    $[19] = breadCrumbsApi;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setWarningShow(false);
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      load: "Map,Placemark,control.ZoomControl,control.FullscreenControl,geoObject.addon.balloon",
      apikey: process.env.NEXT_PUBLIC_YMAPS_API_KEY,
      mode: "release"
    };
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [];
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== currentCoords || $[25] !== zoom) {
    t17 = {
      zoom,
      center: currentCoords,
      controls: t16
    };
    $[24] = currentCoords;
    $[25] = zoom;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      ...mapOptions
    };
    t19 = ["templateLayoutFactory", "Placemark", "geoObject.addon.hint"];
    $[27] = t18;
    $[28] = t19;
  } else {
    t18 = $[27];
    t19 = $[28];
  }
  let t20;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [157, 77];
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      iconLayout: "default#image",
      iconImageHref: logo.src,
      balloonOpenTimeout: 1,
      iconImageSize: t20,
      zIndex: 100,
      zIndexActive: 1001,
      iconOffset: [-70, -52]
    };
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== currentCoords) {
    t22 = <Placemark geometry={currentCoords} options={t21} />;
    $[31] = currentCoords;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      preset: "islands#invertedBlackClusterIcons",
      groupByCoordinates: false,
      gridSize: 128,
      hasBalloon: false
    };
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== onClusterClick) {
    t24 = {
      click: onClusterClick
    };
    $[34] = onClusterClick;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== filteredPlacemarks || $[37] !== ymaps) {
    t25 = filteredPlacemarks?.map(el_0 => <LocationPlacemark key={el_0.id} el={el_0} ymaps={ymaps} activePlacemarkRef={activePlacemarkRef} />);
    $[36] = filteredPlacemarks;
    $[37] = ymaps;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t24 || $[40] !== t25) {
    t26 = <Clusterer options={t23} events={t24}>{t25}</Clusterer>;
    $[39] = t24;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== onZoomChange || $[43] !== t17 || $[44] !== t22 || $[45] !== t26) {
    t27 = <div onTouchMove={handleMapMove} onTouchEnd={t14} className={style.mapBox}><YMaps preload={false} query={t15}><YMap width="100%" height="100%" onLoad={setYmaps} state={t17} options={t18} modules={t19} instanceRef={setMyMap} onZoomChange={onZoomChange} onClick={onMapClick}>{t22}{t26}</YMap></YMaps></div>;
    $[42] = onZoomChange;
    $[43] = t17;
    $[44] = t22;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== myMap) {
    t28 = () => myMap.setZoom(myMap.getZoom() + 1);
    $[47] = myMap;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Svg src={plusIcon.src} alt={"\u0418\u043A\u043E\u043D\u043A\u0430 \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u044F \u043A\u0430\u0440\u0442\u044B"} />;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== t28) {
    t30 = <button onClick={t28}>{t29}</button>;
    $[50] = t28;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== myMap) {
    t31 = () => myMap.setZoom(myMap.getZoom() - 1);
    $[52] = myMap;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Svg src={minusIcon.src} alt={"\u0418\u043A\u043E\u043D\u043A\u0430 \u0443\u043C\u0435\u043D\u044C\u0448\u0435\u043D\u0438\u044F \u043A\u0430\u0440\u0442\u044B"} />;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  let t33;
  if ($[55] !== t31) {
    t33 = <button onClick={t31}>{t32}</button>;
    $[55] = t31;
    $[56] = t33;
  } else {
    t33 = $[56];
  }
  let t34;
  if ($[57] !== t30 || $[58] !== t33) {
    t34 = <div className={style.zoomButtons}>{t30}{t33}</div>;
    $[57] = t30;
    $[58] = t33;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] !== filtersOpen) {
    t35 = () => setFiltersOpen(!filtersOpen);
    $[60] = filtersOpen;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <p className={style.mapFilters_title}>Инфраструктура</p>;
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  const t37 = filtersOpen ? style.opened : style.closed;
  let t38;
  if ($[63] !== t37) {
    t38 = cn(style.arrowRotated, t37);
    $[63] = t37;
    $[64] = t38;
  } else {
    t38 = $[64];
  }
  let t39;
  if ($[65] !== t38) {
    t39 = <Svg src={arrow.src} alt={"\u0418\u043A\u043E\u043D\u043A\u0430 \u0441\u0442\u0440\u0435\u043B\u043A\u0438"} className={t38} />;
    $[65] = t38;
    $[66] = t39;
  } else {
    t39 = $[66];
  }
  const t40 = filtersOpen ? style.opened : style.closed;
  let t41;
  if ($[67] !== t40) {
    t41 = <Svg src={arrow.src} alt={"\u0418\u043A\u043E\u043D\u043A\u0430 \u0441\u0442\u0440\u0435\u043B\u043A\u0438"} className={t40} />;
    $[67] = t40;
    $[68] = t41;
  } else {
    t41 = $[68];
  }
  let t42;
  if ($[69] !== t39 || $[70] !== t41) {
    t42 = <span className={style.mapFilters_arrow}>{t39}{t41}</span>;
    $[69] = t39;
    $[70] = t41;
    $[71] = t42;
  } else {
    t42 = $[71];
  }
  let t43;
  if ($[72] !== t35 || $[73] !== t42) {
    t43 = <div className={style.mapFilters_titleBox} onClick={t35} role="button" tabIndex="0">{t36}{t42}</div>;
    $[72] = t35;
    $[73] = t42;
    $[74] = t43;
  } else {
    t43 = $[74];
  }
  const t44 = filtersOpen ? style.open : "";
  let t45;
  if ($[75] !== t44) {
    t45 = cn(style.mapFilters_list, t44);
    $[75] = t44;
    $[76] = t45;
  } else {
    t45 = $[76];
  }
  let t46;
  if ($[77] !== activeFilter || $[78] !== filterPins || $[79] !== placemarksArr) {
    t46 = mapFilters.map(el_1 => {
      const placemarksLength = placemarksArr.filter(p => p.category === el_1.id).length;
      const iconSrc = activeFilter === el_1.id ? el_1.iconActive?.src : el_1.icon?.src;
      return <li key={el_1.id}><div onClick={() => {
          filterPins(el_1.id);
          setActiveFilter(el_1.id);
        }} role="button" tabIndex="0"><span>{iconSrc && <Svg src={iconSrc} alt={"\u0418\u043A\u043E\u043D\u043A\u0430 \u0444\u0438\u043B\u044C\u0442\u0440\u0430"} />}</span><p>{el_1.title}<span>{placemarksLength > 0 ? placemarksLength : placemarksArr.length}</span></p></div></li>;
    });
    $[77] = activeFilter;
    $[78] = filterPins;
    $[79] = placemarksArr;
    $[80] = t46;
  } else {
    t46 = $[80];
  }
  let t47;
  if ($[81] !== t45 || $[82] !== t46) {
    t47 = <ul className={t45}>{t46}</ul>;
    $[81] = t45;
    $[82] = t46;
    $[83] = t47;
  } else {
    t47 = $[83];
  }
  let t48;
  if ($[84] !== t43 || $[85] !== t47) {
    t48 = <div className={style.mapFilters}>{t43}{t47}</div>;
    $[84] = t43;
    $[85] = t47;
    $[86] = t48;
  } else {
    t48 = $[86];
  }
  let t49;
  if ($[87] !== isDesktop || $[88] !== warningShow) {
    t49 = warningShow && !isDesktop && <div className={style.warning}><p>Чтобы переместить карту, проведите по ней двумя пальцами</p></div>;
    $[87] = isDesktop;
    $[88] = warningShow;
    $[89] = t49;
  } else {
    t49 = $[89];
  }
  let t50;
  if ($[90] !== t13 || $[91] !== t27 || $[92] !== t34 || $[93] !== t48 || $[94] !== t49) {
    t50 = <section className={style.wrapper}>{t13}{t27}{t34}{t48}{t49}</section>;
    $[90] = t13;
    $[91] = t27;
    $[92] = t34;
    $[93] = t48;
    $[94] = t49;
    $[95] = t50;
  } else {
    t50 = $[95];
  }
  return t50;
};
export default LocationMap;